import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/X";
import Google from "@mui/icons-material/Google";
import { useTheme, useMediaQuery } from "@mui/material";

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: "text.primary", mt: { xs: 1, sm: 0 } }}>
      {"Copyright © "}
      <Link color="text.primary" href="https://mydivingsites.com/">
        mydivingsites.com LLC 
      </Link>
       {" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 2, sm: 4, md: 6 },
        py: { xs: 2, sm: 3, md: 5 },
        textAlign: { xs: "center", md: "center" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          borderTop: "2px solid",
          borderColor: "divider",
          paddingTop: { xs: 2, sm: 3, md: 4 },
        }}
      />
      
      {/* DAN Referral Images */}
      <Box 
        sx={{ 
          width: "100%", 
          display: "flex", 
          justifyContent: "center",
          px: { xs: 1, sm: 2 }
        }}
      >
        <Stack 
          direction={{ xs: "column", sm: "row" }} 
          spacing={{ xs: 2, sm: 2, md: 3 }}
          alignItems="center"
        >
          <Link
            href="https://apps.dan.org/join-dan/?rc=3283553"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/dan-referral.jpg"
              alt="Dan Referral"
              style={{ 
                maxWidth: "100%", 
                height: "auto",
                maxHeight: isMobile ? "100px" : "auto"
              }}
            />
          </Link>

          <Link
            href="https://dan.org/partner/3283553/trip"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/dan-travel-insurance.jpg"
              alt="Dan Travel Insurance"
              style={{ 
                maxWidth: "100%", 
                height: "auto",
                maxHeight: isMobile ? "100px" : "auto"
              }}
            />
          </Link>
        </Stack>
      </Box>

      {/* Social Media Icons (commented out but responsive) */}
      <Box>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          justifyContent="center"
          color="text.primary"
        >
          {/* Social media icons commented out in original code */}
        </Stack>
      </Box>

      {/* Footer Links */}
      <Box sx={{ width: "100%" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 0 }}
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
          color="text.primary"
          alignItems="center"
        >
          <Link
            color="text.primary"
            variant="body2"
            href="docs/PRIVACY-NOTICE.pdf"
            target="_blank"
            sx={{ mx: { sm: 1 } }}
          >
            Privacy Policy
          </Link>
          
          <Typography 
            sx={{ 
              display: { xs: "none", sm: "inline" }, 
              opacity: 0.5 
            }}
          >
            •
          </Typography>
          
          <Link
            color="text.primary"
            variant="body2"
            href="docs/TERMS-AND-CONDITIONS.pdf"
            target="_blank"
            sx={{ mx: { sm: 1 } }}
          >
            Terms of Service
          </Link>
          
          <Typography 
            sx={{ 
              display: { xs: "none", sm: "inline" }, 
              opacity: 0.5 
            }}
          >
            •
          </Typography>
          
          <Box sx={{ 
            display: { xs: "block", sm: "inline" },
            mx: { sm: 1 }
          }}>
            <Copyright />
          </Box>
          
          <Typography 
            sx={{ 
              display: { xs: "none", sm: "inline" }, 
              opacity: 0.5 
            }}
          >
            •
          </Typography>
          
          <Link
            color="text.primary"
            variant="body2"
            href="mailto:contactus@mydivingsites.com"
            target="_blank"
            sx={{ mx: { sm: 1 } }}
          >
            Contact us
          </Link>
          
          <Typography 
            sx={{ 
              display: { xs: "none", sm: "inline" }, 
              opacity: 0.5 
            }}
          >
            •
          </Typography>
          
          <Link
            color="text.primary"
            variant="body2"
            href="docs/COOKIE-POLICY.pdf"
            target="_blank"
            sx={{ mx: { sm: 1 } }}
          >
            Cookie Policy
          </Link>
        </Stack>

        <Box sx={{ mt: { xs: 2, sm: 3 } }}>
          <Typography
            variant="body2"
            sx={{ color: "text.primary", textAlign: "center" }}
          >
            <Link
              color="text.primary"
              href="https://visitbainbridgeisland.org/"
              target="_blank"
            >
              Built on Bainbridge Island
            </Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
